export enum AddonFormEvent {
  ToggleUpdate = 'AddonFormToggleEvent',
  ViewUpdate = 'AddonFormViewUpdateEvent',
}
